import React, { FC, memo } from 'react'
import useIsSp from 'hooks/useIsSp'
import { TelInputProps } from './types'
import SpTelInput from './SpTelInput'
import PcTelInput from './PcTelInput'

const TelInput: FC<TelInputProps> = (props) => {
  const isSp = useIsSp()

  return isSp ? <SpTelInput {...props} /> : <PcTelInput {...props} />
}

export default memo(TelInput)
